import { render, staticRenderFns } from "./FanCoilDetail.vue?vue&type=template&id=53d5489b&scoped=true&"
import script from "./FanCoilDetail.vue?vue&type=script&lang=js&"
export * from "./FanCoilDetail.vue?vue&type=script&lang=js&"
import style0 from "./FanCoilDetail.vue?vue&type=style&index=0&id=53d5489b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5489b",
  null
  
)

export default component.exports